import {useLoaderData, Link} from 'react-router-dom';
import React, {useState, useEffect} from "react";
import { useUser } from "../components/UserContext";
import { getUserManager, updateUsers, initialiseBaseSkins } from '../Users'
// import PaymentIcon from '@mui/icons-material/Payment';
import PersonIcon from '@mui/icons-material/Person';

export async function loader({params}) {
    const userId = params.userId;
    const users = await getUserManager(userId);
    if (Number(userId) !== 1) {
        throw new Response("", {
            status: 404,
            statusText: "Not Found",
        });
    }
    return {users};
}

export default function ManageUsers() {
    const {users} = useLoaderData();
    const {currentUser} = useUser();
    const [input, setInput] = useState([{pfp: null, name: "ruby willow", username: "ruby !", email: "rubywkimber@gmail.com", status: 2}]);

    useEffect(() => {
        initialiseBaseSkins(currentUser.id);
        document.title = "manage users";
        if (users && users.length >= 0) {
            setInput(users.map(u => ({ ...u, status: Number(u.status) })));
        }
    }, [currentUser.id, users]);

    function updateUserField(index, field, value) {
        setInput(prev => {
            const next = [...prev];
            next[index] = { ...next[index], [field]: value };
            return next;
        });
    }

    function edit(newItem) {
        updateUsers(newItem);
        window.location.reload();
    }

    function submit() {
        const newItem = [...input];
        edit(newItem);
    }

    if (Number(currentUser.id) === 1) return(
        <div>
            <div className="page-head">
                <div className="page-title settings-title">
                    <div className="creator-pfp">
                        {/* <PaymentIcon className="creator-default-pfp"/> */}
                        </div>
                    <h2 className="title-text">manage users</h2>
                    <h3>manage users' access</h3>
                </div>
            </div>
            <div>
                <div id="folder-create-container">
                    <div id="skin-create">
                        <div>
                            <div>
                                <div className="user-manager-row">
                                    <div>
                                        <p/>
                                        <p>name</p>
                                        <p>username</p>
                                        <p>email</p>
                                    </div>
                                    <div>
                                        <p>active</p>
                                        <p>inactive</p>
                                        <p>pending</p>
                                        <p>banned</p>
                                    </div>
                                </div>
                                {input.map((user, index) => {
                                    // unique group name per user so radios don't collide across rows
                                    const groupName = `status-${index}`;

                                    return (
                                        <div key={user.id ?? index} className="user-manager-row">
                                        <Link to={`/profile/${user.id}`}>
                                            {user.pfp ? (
                                            <img className="user-manager-pfp" src={user.pfp} alt="user profile" />
                                            ) : (
                                            <PersonIcon className="user-manager-pfp" />
                                            )}
                                            <p>{user.name}</p>
                                            <p>{user.username}</p>
                                            <p>{user.email}</p>
                                        </Link>

                                        <fieldset>
                                            <input
                                            type="radio"
                                            id={`active-${index}`}
                                            name={groupName}
                                            value="2"
                                            checked={user.status === 2}
                                            onChange={() => updateUserField(index, "status", 2)}
                                            />

                                            <input
                                            type="radio"
                                            id={`inactive-${index}`}
                                            name={groupName}
                                            value="1"
                                            checked={user.status === 1}
                                            onChange={() => updateUserField(index, "status", 1)}
                                            />

                                            <input
                                            type="radio"
                                            id={`pending-${index}`}
                                            name={groupName}
                                            value="0"
                                            checked={user.status === 0}
                                            onChange={() => updateUserField(index, "status", 0)}
                                            />

                                            <input
                                            type="radio"
                                            id={`banned-${index}`}
                                            name={groupName}
                                            value="-1"
                                            checked={user.status === -1}
                                            onChange={() => updateUserField(index, "status", -1)}
                                            />
                                        </fieldset>
                                        </div>
                                    );
                                    })}
                            </div>
                        </div>

                        <div id="skin-submit-container">
                            <div>
                                <button id="folder-submit-button" onClick={submit}>Submit</button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}